const MARQUEE_WORDS = [
  "VERLÄSSLICH",
  "PERSÖNLICH",
  "SÜDHESSEN",
  "HANDWERKLICH",
  "TRANSPARENT",
  "REGIONAL",
];

const VALUES = [
  {
    n: "100%",
    label: "Persönlicher Kontakt",
    text: "Kein Callcenter, keine wechselnden Ansprechpartner. Sie reden direkt mit mir.",
  },
  {
    n: "1",
    label: "Ansprechpartner",
    text: "Vom Verkauf bis zur Pflege — alles aus einer Hand, ohne Schnittstellenchaos.",
  },
  {
    n: "∞",
    label: "Hands-on Mentalität",
    text: "Wo andere telefonieren, hole ich den Werkzeugkasten. Wenn es sinnvoll ist.",
  },
];

export default function TrustValues() {
  const repeated = [...MARQUEE_WORDS, ...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section
      id="werte"
      data-testid="trust-section"
      className="bg-[#0A0A0A] text-white py-24 lg:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-10 bg-[#8A151B]" />
              <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#8A151B]">
                Werte
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.05]">
              Was Sie von mir
              <br />
              erwarten dürfen.
            </h2>
            <p className="mt-8 text-neutral-400 leading-relaxed max-w-md">
              In Südhessen verwurzelt, mit klaren Werten unterwegs.
              Ehrliches Handwerk im Maklergeschäft — und darüber hinaus.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-3 gap-px bg-neutral-800">
            {VALUES.map((v, i) => (
              <div
                key={v.label}
                data-testid={`value-card-${i}`}
                className="bg-[#0A0A0A] p-8 lg:p-10 hover:bg-[#171717] transition-colors"
              >
                <p className="font-display text-6xl lg:text-7xl font-black text-[#8A151B] leading-none">
                  {v.n}
                </p>
                <p className="mt-6 text-xs uppercase tracking-[0.25em] font-bold text-white">
                  {v.label}
                </p>
                <p className="mt-3 text-sm text-neutral-400 leading-relaxed">
                  {v.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div
        data-testid="marquee"
        className="mt-24 lg:mt-32 border-t border-b border-neutral-800 py-8 overflow-hidden whitespace-nowrap"
      >
        <div className="marquee-track inline-flex gap-12">
          {repeated.map((w, i) => (
            <span
              key={i}
              className="font-display text-4xl sm:text-6xl font-black tracking-tighter uppercase text-white"
            >
              {w}
              <span className="text-[#8A151B] ml-12">●</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
